import { PinBold } from '@ha/icons';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { units } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  root: {
    stroke: theme.palette.grey[500],
    fontSize: units.rem(0.75),
  },
}));

const ListingAddressIcon: React.FC<{}> = () => {
  const { classes } = useStyles();

  return <PinBold className={classes.root} />;
};

export { ListingAddressIcon };
